import React, { Component } from 'react'
import ReactPlayer from 'react-player'
import { Close } from '../icons/index'
import { BROWSER } from '../../browser-detect'
import './_fullscreen.scss'

const CloseButton = props => (
  <button className="close_button" onClick={props.handleClick}>
    <Close />
  </button>
)

export default class FullScreen extends Component {
  constructor(props) {
    super(props)

    this.state = {
      menuOpen: false,
      activeVideo: {}
    }
  }

  componentWillMount() {
    const { video } = this.props
    this.setState({
      activeVideo: video
    })
  }
  runMediaMatchListener = vid => {
    if (BROWSER.isSafari() === false) {
      vid.addEventListener('loadeddata', () => {
        if (vid.readyState >= 2) {
          vid.play()
        }
      })
    }
    vid.addEventListener('loadeddata', () => {
      if (vid.readyState >= 2 && BROWSER.isSafari() === false) {
        vid.play()
      }
    })

    if (BROWSER.mQ(768).matches) {
      vid.addEventListener('click', () => {
        vid.play()
      })
    }
    if (BROWSER.isSafari() && BROWSER.isChrome() === false && BROWSER.mQ(768).matches) {
      if (vid.readyState >= 2) {
        vid.addEventListener('click', () => {
          vid.setAttribute('muted', false)
        })
      }
    }
    vid.addEventListener('loadeddata', () => {
      if (vid.readyState >= 2 && BROWSER.isSafari() === false) {
        vid.play()
      }
    })
  }
  componentDidMount() {
    if (BROWSER.isExplorer()) {
      BROWSER.handlePolyfill()
      const _video = document.querySelector(`.full_screen_video .video_${this.props.videoIndex} video`)
  
      if (_video) {
        _video.addEventListener('loadeddata', () => {
          if (_video.readyState >= 2) {
            _video.play()
          }
        })
      }

    } else {
      const videos = document.querySelectorAll('video')
      const fsUrlVid = this.reactPlayer.getInternalPlayer()
      const { activeVideo } = this.state
      const _this = this
      const _video = document.querySelector(`.full_screen_video .video_${this.props.videoIndex} video`)
      const modal = document.querySelector('.Modal')
      this.reactPlayer.config.file.forceVideo = true
  
      if (fsUrlVid) {
        fsUrlVid.poster = activeVideo.fsPoster
        this.runMediaMatchListener(fsUrlVid)
      }
  
      if (_video) {
        _video.addEventListener('loadeddata', () => {
          if (_video.readyState >= 2) {
            _video.play()
          }
        })
      }
    }
   
  }

  handlePlay = () => {
    const fsUrlVid = this.reactPlayer.getInternalPlayer()
    if (fsUrlVid) {
      this.runMediaMatchListener(fsUrlVid)
    }
  }

  handleClick = () => this.props.closeFullScreen()

  render() {
    const { videos } = this.props
    const { activeVideo } = this.state
    

    if (BROWSER.isSafari() && BROWSER.isChrome() === false) {
      return (
        <div className="FullScreen full_screen_container">
          <div className="content-wrap">
            <div className="content">
              <div>
                <ReactPlayer
                  playing
                  playsinline
                  onCanPlay={this.handlePlay}
                  muted
                  url={[{ src: this.state.activeVideo ? activeVideo.url : null, type: 'video/mp4' }]}
                  className={`full_screen_video video_${this.props.videoIndex}`}
                  height="100%"
                  width="100%"
                  ref={reactPlayer => (this.reactPlayer = reactPlayer)}
                  controls={true}
                />
                <CloseButton handleClick={this.handleClick} />
              </div>
            </div>
          </div>
        </div>
      )
    } else if (BROWSER.isSafari() === false && BROWSER.isChrome()) {
      return (
        <div className="FullScreen full_screen_container">
          <div className="content-wrap">
            <div className="content">
              <div>
                <ReactPlayer
                  playing
                  url={[{ src: this.state.activeVideo ? activeVideo.url : null, type: 'video/mp4' }]}
                  className={`full_screen_video video_${this.props.videoIndex}`}
                  height="100%"
                  width="100%"
                  ref={reactPlayer => (this.reactPlayer = reactPlayer)}
                  controls={true}
                />
                <CloseButton handleClick={this.handleClick} />
              </div>
            </div>
          </div>
        </div>
      )
    } else if (BROWSER.isExplorer()) {
      console.log('Internet explorer video player')
      return (
        <div className="FullScreen full_screen_container">
          <div className="content-wrap">
            <div className="content">
              <div>
                <ReactPlayer
                  url={this.state.activeVideo ? activeVideo.url : null}
                  className={`full_screen_video video_${this.props.videoIndex}`}
                  height="100%"
                  width="100%"
                  controls={true}
                />
                <CloseButton handleClick={this.handleClick} />
              </div>
            </div>
          </div>
        </div>
      )
    } else {
      return (
        <div className="FullScreen full_screen_container">
          <div className="content-wrap">
            <div className="content">
              <div>
                <ReactPlayer
                  playing
                  url={[{ src: this.state.activeVideo ? activeVideo.url : null, type: 'video/mp4' }]}
                  className={`full_screen_video video_${this.props.videoIndex}`}
                  height="100%"
                  width="100%"
                  ref={reactPlayer => (this.reactPlayer = reactPlayer)}
                  controls={true}
                />
                <CloseButton handleClick={this.handleClick} />
              </div>
            </div>
          </div>
        </div>
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/fullscreen/index.js